var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.tablePagination && _vm.tablePagination.last_page > 1,
          expression: "tablePagination && tablePagination.last_page > 1",
        },
      ],
      class: _vm.css.wrapperClass,
    },
    [
      _vm.windowStart > 1
        ? _c(
            "a",
            {
              class: [_vm.isOnFirstPage ? _vm.css.disabledClass : ""],
              on: {
                click: function ($event) {
                  return _vm.loadPage(1)
                },
              },
            },
            [_vm._v("1")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.windowStart > 2 ? _c("span", [_vm._v("...")]) : _vm._e(),
      _vm._v(" "),
      _vm.notEnoughPages
        ? [
            _vm._l(_vm.totalPage, function (n) {
              return [
                _c("a", {
                  class: [
                    _vm.css.pageClass,
                    _vm.isCurrentPage(n) ? _vm.css.activeClass : "",
                  ],
                  domProps: { innerHTML: _vm._s(n) },
                  on: {
                    click: function ($event) {
                      return _vm.loadPage(n)
                    },
                  },
                }),
              ]
            }),
          ]
        : [
            _vm._l(_vm.windowSize, function (n) {
              return [
                _c("a", {
                  class: [
                    _vm.css.pageClass,
                    _vm.isCurrentPage(_vm.windowStart + n - 1)
                      ? _vm.css.activeClass
                      : "",
                  ],
                  domProps: { innerHTML: _vm._s(_vm.windowStart + n - 1) },
                  on: {
                    click: function ($event) {
                      return _vm.loadPage(_vm.windowStart + n - 1)
                    },
                  },
                }),
              ]
            }),
            _vm._v(" "),
            _vm.windowEnd < _vm.totalPage - 1
              ? _c("span", [_vm._v("...")])
              : _vm._e(),
            _vm._v(" "),
            _vm.windowEnd < _vm.totalPage
              ? _c("a", {
                  class: [_vm.isOnLastPage ? _vm.css.disabledClass : ""],
                  domProps: { innerHTML: _vm._s(_vm.totalPage) },
                  on: {
                    click: function ($event) {
                      return _vm.loadPage(_vm.totalPage)
                    },
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }